type SuccessNotificationListener = (message: string) => void;

const listeners = new Set<SuccessNotificationListener>();

export function notifySuccess(message: string): void {
  listeners.forEach((listener) => listener(message));
}

export function subscribeToSuccessNotifications(
  listener: SuccessNotificationListener,
): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
